import {
  FundingProgramAbbreviation,
  TrackingEvent,
  makeBannerTrackingName,
} from "@outschool/funding-programs-shared";
import { useTranslation } from "@outschool/localization";
import { esaFundsLoggedInBannerCtaPath } from "@outschool/routes";
import { ExternalLink, TrackedButton } from "@outschool/ui-components-shared";
import React from "react";

import lightBulbImage from "../../images/home/lightbulb.svg";
import MarketingBanner from "./MarketingBanner";

const ESAFundsBanner = () => {
  const { t } = useTranslation(
    "ui-components-website\\Banners\\ESAFundsBanner"
  );
  const title = t("Use your ESA funds on Outschool");
  const description = t(
    "Arizona families with Empowerment Scholarship Accounts (ESA) can now use ClassWallet to access Outschool classes."
  );
  const cta = t("Learn How It Works");
  const properties = {
    fundingProgram: FundingProgramAbbreviation.AZ,
    component: "ESAFundsBanner",
  };
  return (
    <MarketingBanner
      title={title}
      content={description}
      cta={
        <TrackedButton
          trackViews
          variant="contained"
          trackingViewEventName={makeBannerTrackingName(
            TrackingEvent.BannerView
          )}
          component={ExternalLink}
          url={esaFundsLoggedInBannerCtaPath()}
          trackingName={makeBannerTrackingName(TrackingEvent.ProgramUrl)}
          trackingSharedProperties={properties}
        >
          {cta}
        </TrackedButton>
      }
      imagePath={lightBulbImage}
    />
  );
};

export default ESAFundsBanner;
